import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getUsers({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_USERS_REQUEST')

        return axios
            .get(`/users/users${paginate}${query}`)
            .then(response => {
                commit('GET_USERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_USERS_FAILURE')
                handleApiError(error, 'Pobranie listy użytkowników nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getUser(context, userId) {
        return axios
            .get(`/users/users/${userId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych użytkownika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateUser({ commit }, { id, payload }) {
        return axios
            .patch(`/users/users/${id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Użytkownik został zedytowany.'
                }, { root: true })

                commit('SAVE_USER', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja użytkownika nie powiodła się.')

                return Promise.reject(error)
            })
    },
    addUser({ commit }, { payload }) {
        return axios
            .post('/users/users', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dodano nowego użytkownika.'
                }, { root: true })

                commit('SAVE_USER', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie nowego użytkownika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionDepartments({ commit }, {
        query = ''
    } = {}) {
        return axios
            .get(`/production-departments/dicts/production-departments${query}`)
            .then(response => {
                commit('GET_PRODUCTION_DEPARTMENTS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie działów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getStopCardsProductionDepartments({ commit }, {
        query = ''
    } = {}) {
        return axios
            .get(`/production-departments/dicts/card-stop-production-departments${query}`)
            .then(response => {
                commit('GET_STOP_CARD_PRODUCTION_DEPARTMENTS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie działów dla kart stop nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setUsersFilters({ commit }, filters) {
        commit('SET_USERS_FILTERS', filters)
    },
    getUserPositions({ commit }) {
        return axios
            .get('/users/dicts/user-positions')
            .then(response => {
                commit('GET_USER_POSITIONS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie stanowisk nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getUserSquads({ commit }) {
        return axios
            .get('/users/dicts/user-squads')
            .then(response => {
                commit('GET_USER_SQUADS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie brygad nie powiodło się.')

                return Promise.reject(error)
            })
    },
    findUsers(context, payload) {
        return axios
            .get(`/users/users${payload.paginate}&search=${payload.query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Szukanie nie powiodło się.')

                return Promise.reject(error)
            })
    },
    findActiveUsers(context, { paginate, query }) {
        return axios
            .get(`/users/users${paginate}&isActive=true&search=${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Szukanie aktywnych użytkowników nie powiodło się.')

                return Promise.reject(error)
            })
    },
    receiveUsers(context, payload) {
        return axios
            .get(`/users/users${payload.paginate}${payload.query}&search=${payload.search}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Szukanie nie powiodło się.')

                return Promise.reject(error)
            })
    },
    clearUsersFilters({ commit }) {
        commit('CLEAR_USERS_FILTERS')
    },
    getUserRoles({ commit }) {
        return axios
            .get('/users/user-permission-roles')
            .then(response => {
                commit('GET_USER_ROLES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie ról użytkowników nie powiodło się.')

                return Promise.reject(error)
            })
    }
}
